import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import usageTypes from '../../constants/UsageType';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    openAddProgress,
    progressOkAction,
    loading,
    resultMessage,
    shopId,
    menuId,
    usedAmount,
    usedAt,
    userKidIdsAdd,
    userKids,
    shops,
    menus,
    userName,
    errorMessage,
    updateErrorMessage,
    menuPriceObj,
    groupSpecials,
    groupGochiKidId,
    usageType,
    taxRate
  }) => {
    const userKidNameList = userKids.filter(userKid =>
      userKidIdsAdd.includes(userKid.userKidId)
    );

    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    return (
      <div className={classes.root}>
        <Typography variant="h6">こどもごちめし利用データ登録</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ユーザー名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {userName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                資金グループ
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {groupSpecials.map(item => {
                  if (parseInt(groupGochiKidId, 10) === item.gochiKidGroupId) {
                    return item.gochiKidGroupName;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗名</TableCell>
              <TableCell className={classes.tableCellData}>
                {shops.map(item => {
                  if (parseInt(shopId, 10) === item.shopId) {
                    return item.shopName;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                メニュー名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10)
                  ? '金額指定メニュー'
                  : menus.map(item => {
                      if (parseInt(menuId, 10) === item.menuId) {
                        return item.menuName;
                      }
                      return '';
                    })}
              </TableCell>
            </TableRow>
            {parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10) && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用税込金額
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {usedAmount}
                </TableCell>
              </TableRow>
            )}
            {(parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10) ||
              usageType === USAGE_TYPE_VOUCHER) && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  消費税区分
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${taxRate * 100}%`}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>利用日時</TableCell>
              <TableCell className={classes.tableCellData}>{usedAt}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                利用するお子さま
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {userKidNameList.length > 0 &&
                  userKidNameList.map(item => {
                    return <div key={item.userKidId}>{item.displayName}</div>;
                  })}
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => updateErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
        <ProgressDialog
          openProgress={openAddProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
